import { useMutation } from '@apollo/client/react';
import { useContext } from 'react';
import { toast } from 'react-toastify';

import { AppContext } from '../App';
import { CookingStationName, ExportMetricsTypeEnum } from '../libs';
import { EXPORT_QUALITY_METRICS_MUTATION } from '../libs/graphQL';

const useExportQualityMetricsMutation = () => {
  const [exportQualityMetrics, { loading }] = useMutation(EXPORT_QUALITY_METRICS_MUTATION);
  const { user } = useContext(AppContext);

  const handleExportQualityMetrics = async ({
    startDate,
    endDate,
    kitchen,
    type,
    stations
  }: {
    startDate: string;
    endDate: string;
    kitchen: string;
    type: ExportMetricsTypeEnum;
    stations?: CookingStationName[];
  }) => {
    await exportQualityMetrics({
      variables: { email: user.email, startDate, endDate, kitchen, type, stations },
      onCompleted: () => {
        toast.success('Quality Metrics report will be sent to your email shortly');
      },
      onError: (e) => {
        toast.error(e.message);
      }
    }).catch(() => undefined);
  };

  return { handleExportQualityMetrics, loading };
};

export default useExportQualityMetricsMutation;
